import singularize from './singularize'

export default (count, string = '') => {
  if (count === 1) {
    return singularize(string)
  }

  return string
}
